module.exports = __webpack_public_path__ + "img/vertical_4_1_0.bfa4673f.png";